export default __webpack_public_path__ + "static/media/UNTERNEHMENSAUSKUNFT.343b0774.png";